import {useMemo} from 'react';
import {assert} from 'assert-ts';

import type {ManifestationItem} from 'services/metadata/types';

export const useMovedManifestationId = (
  content: ManifestationItem[],
): string => {
  return useMemo(() => {
    assert(
      content.length === 1,
      `NewExpression: Only one manifestation is supported, got ${content.length}`,
      content,
    );
    assert(
      content[0].type === 'manifestation',
      'NewExpression: Content must be manifestation',
      content,
    );
    const manifestationId = content[0].id;
    return manifestationId;
  }, [content]);
};
